import React from 'react';
import { useIntl } from 'react-intl';
import { Spinner } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { faCircleExclamation } from '@fortawesome/pro-light-svg-icons/faCircleExclamation';
import { TypedMemo } from '../../common/types';
import { settingsCommonMessages } from './settingsCommonMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Settings tabs; each part uses its own slice of it */
import styles from './settingsCards.module.scss';
/* eslint-enable css-modules/no-unused-class */

export type SettingsSaveState = 'idle' | 'saving' | 'saved' | 'failed';

interface Props {
  state: SettingsSaveState;
}

/** "Saving", "Saved" or the save error, in a tab head (design settings-redesign c1, c3). */
const SettingsSaveStatusComponent: React.FC<Props> = ({ state }) => {
  const intl = useIntl();
  if (state === 'idle') {
    return null;
  }
  if (state === 'saving') {
    return (
      <span className={styles.saving} role="status">
        <Spinner size="sm" />
        {intl.formatMessage(settingsCommonMessages.saving)}
      </span>
    );
  }
  if (state === 'saved') {
    return (
      <span className={styles.saved} role="status">
        <FontAwesomeIcon icon={faCheck} />
        {intl.formatMessage(settingsCommonMessages.saved)}
      </span>
    );
  }
  return (
    <span className={`${styles.pill} ${styles.pillNeg}`} role="alert">
      <FontAwesomeIcon icon={faCircleExclamation} />
      {intl.formatMessage(settingsCommonMessages.saveFailed)}
    </span>
  );
};

export const SettingsSaveStatus = TypedMemo(SettingsSaveStatusComponent);
